import { useSelector } from "react-redux";

import { getUserPreferenceValue } from "fond/api";
import { Store, UserPreferenceKey, UserPreferenceSubKey } from "fond/types";

type PinnedAccountItem = {
  account_id: string;
};

/**
 * Lightweight hook to read pinned account IDs from user preferences.
 * Unlike usePinned(), this does not set up mutations, queries, or snackbar wiring.
 * Use this when you only need to read pinned IDs without mutation capabilities.
 */
export const usePinnedAccountIds = (): string[] => {
  const pinnedFromPreferences = useSelector((state: Store) =>
    getUserPreferenceValue(state, UserPreferenceKey.ACCOUNT_NAVIGATION, UserPreferenceSubKey.PINNED_ACCOUNTS)
  );

  if (pinnedFromPreferences && Array.isArray(pinnedFromPreferences)) {
    return (pinnedFromPreferences as PinnedAccountItem[]).map((item) => item.account_id).filter(Boolean);
  }

  return [];
};
